<template>
  <div class="propagandas">
    <el-row class="data-total">
      <el-col
        class="total-item"
        :lg="6"
        :md="6"
        :sm="12"
        :xs="12"
      >
        <div class="label">{{$t('Customet_Equity')}} ({{currency}})</div>
        <div class="data">{{ statistics.subEquity }} </div>
      </el-col>
      <el-col
        class="total-item"
        :lg="6"
        :md="6"
        :sm="12"
        :xs="12"
      >
        <div class="label">{{$t('clientBanlance')}} ({{currency}})</div>
        <div class="data">{{ statistics.subBalance }} </div>
      </el-col>
      <el-col
        :lg="6"
        :md="6"
        :sm="12"
        :xs="12"
        class="total-item">
        <div class="label">{{$t('Home.forexVolume')}} (Lots)</div>
        <div class="data">{{ statistics.subLots }}</div>
      </el-col>
      <el-col
        :lg="6"
        :md="6"
        :sm="12"
        :xs="12"
        class="total-item"
      >
        <div class="label">{{$t('Commission_is_available')}} ({{currency}})</div>
        <div class="data special-data">
          <span class="outer-left-btn">{{ statistics.remainAmount }} </span>
          <el-button
            :disabled="outBtnDisable"
            type="primary"
            size="small"
            @click="outHandle"
          >{{$t('Commission')}}</el-button>
        </div>
      </el-col>
    </el-row>
    <div class="my-rule">
      <div class="header">
        <div class="title">{{$t('My_rebate_rules')}}</div>
      </div>
      <div class="content RuleTable-outer rule-table-outer">
        <RuleTable
          :isReadonly="true"
          :ruleData="partner.ruleList"
          ref="ruletable"
        />
      </div>
    </div>
    <div class="customer-link">
      <div class="link-group">
        <div class="group-title">
          {{$t('Direct_link')}}
        </div>
        <div
          v-for="(item,index) in guestInvitationLinks"
          :key="index"
          class="bg-box">
          <div class="bg-left">
            <el-image
              class="qr-code"
              style="width: 80px;height: 80px;    "
              :src="item.qrForCust"
              :preview-src-list="[item.qrForCust]"
            ></el-image>
          </div>
          <div class="bg-right">
            <div class="link-title">
              <span class="pointer" @click="lookDirectRuleInfoHandle(item)">{{ item.defaultFlag == 1?$t('Direct_link'):item.levelName}}     </span>
              <span class="title-right">
                <i
                  @click="copyHandle(item.linkForCust)"
                  class="iconfont icon-copy1 pointer"
                ></i>
                <i
                  style="margin-left: 10px;"
                  @click="lookDirectRuleInfoHandle(item)"
                  class="iconfont icon-eye pointer"
                ></i>
              </span>
            </div>
            <div class="link-text">{{item.linkForCust}}</div>
          </div>
        </div>
      </div>
      <div
        v-if="userInfo.hierarchy >= 2"
        class="link-group">
        <div class="subib-group-title">
          <span class="group-title">{{$t('Sub_IB_link')}}</span>
          <el-button
            v-if="userInfo.addLevelFlag"
            type="primary"
            @click="addSubLinkHandle"
            size="small"
          >{{$t('Add_a_link')}}</el-button>
        </div>
        <div class="link-item"
             v-for="(item,index) in subIbInfoList"
             :key="index"
        >
          <div class="bg-box">
            <div class="bg-left">
              <el-image
                class="qr-code"
                style="width: 80px;height: 80px;"
                :src="item.qrCodeUrl"
                :preview-src-list="[item.qrCodeUrl]"
              ></el-image>
            </div>
            <div class="bg-right">
              <div class="link-title">
                <span>{{item.levelName}}</span>
                <div class="link-title-right">
                  <i
                    @click="copyHandle(item.link)"
                    class="iconfont icon-copy1 pointer"
                  ></i>
                  <i
                    v-if="item.modifyRuleFlag&&userInfo.addLevelFlag"
                    @click="editHandle(item)"
                    class="iconfont icon-edit-21 pointer"
                  ></i>
                  <i v-else
                  style="margin-left: 10px;"
                  @click="lookDirectRuleInfoHandle(item)"
                  class="iconfont icon-eye pointer"
                ></i>
                </div>
              </div>
              <div class="link-text">{{item.link}}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <out-commission-dialog
      ref="outcommission"
      :remain-amount="statistics.remainAmount"
      :dialog-show="dialogShow"
      @close="dialogShow = false"
      @outCommission-success="outCommissionSuccess"
      @add-collection="addCollection"
    ></out-commission-dialog>
    <look-direct-rule-dialog
      :dialog-show="lookRuleDialogShow"
      :direct-rule-info="currentDirectRuleInfo"
      @close="closeLookDialog"
      :rule-list="partner.ruleList"

    ></look-direct-rule-dialog>
    <add-sub-ib-rule-dialog
      :dialog-show="addRuleDialogShow"
      :template-list="templateList"
      @close="closeAddRuleDialog"
      @add-success="addSuccess"
    ></add-sub-ib-rule-dialog>
    <edit-sub-ib-rule-dialog
      :dialog-show="editRuleDialogShow"
      :current-sub-ib-info="currentSubIbInfo"
      :father-rule-data="myRuleData"
      :sub-rule-data="currentSubRuleData"
      @close="closeEditRuleDialog"
      @edit-suceess="editSuccess"
    ></edit-sub-ib-rule-dialog>

    <bank-info-edit-dialog
      :dialog-show="bankInfoDialogShow"
      @close="closeBankInfoHandel"
      @ajax-success="editBankInfoSuccess"
    ></bank-info-edit-dialog>

    <bar-info-edit-dialog
      :dialog-show="barInfoDialogShow"
      :channel-info="channelInfo"
      :bar-title="barTitle"
      @close="closeBarInfoHandel"
      @ajax-success="barInfoAjaxSuccess"
    ></bar-info-edit-dialog>
  </div>
</template>

<script>
import { toggleStockMaxAndValue } from "@/utils/common";
// 绑定收款信息的
import {getCustPayTypes} from '@/api/user.js';

import barInfoEditDialog from "@/components/myFiles/collection/barInfoEditDialog";

import bankInfoEditDialog from "@/components/myFiles/collection/bankInfoEditDialog"

import editSubIbRuleDialog from "@/components/agent/propagandas/editSubIbRuleDialog";
import addSubIbRuleDialog from "@/components/agent/propagandas/addSubIbRuleDialog";
import lookDirectRuleDialog from "@/components/agent/propagandas/lookDirectRuleDialog";
import outCommissionDialog from "@/components/agent/outCommissionDialog";
import { getPartnerCenterData, getUserDefinedGroupConfigList,addDirectGuestInvitationLinks, getDirectGuestInvitationLinks,editDirectGuestInvitationLinks,getPartnerInfo,queryTMerchantCommissionLevels,queryTMerchantCommissionLevelsRule } from '@/api/userCenter.js';
import { mapGetters } from 'vuex';
import copy from 'copy-to-clipboard';
export default {
  name: "index",
  components:{
    outCommissionDialog,
    lookDirectRuleDialog,
    addSubIbRuleDialog,
    editSubIbRuleDialog,

    bankInfoEditDialog,
    barInfoEditDialog,
  },
  data() {
    return {
      currency: 'USD',
      statistics:{
        remainAmount: '', //可出佣金额
        totalAmount: '',//佣金总额
        custNumber: '',// 客户数
        ibCustNumber: '',// ib数
        loginNumber: '',// 客户账户数
        equity: '',// 净值
        balance: '', //余额
        nowVolume: '',//当前手数
        totalVolume: '',// 累积手数

        subEquity: '', // 客户净值
        subBalance: '', // 客户余额
        subLots: '', // 交易量
      },
      partner:{
        ruleList: [],
      },
      guestInvitationLinks: [],
      dialogShow: false,

      subIbInfoList: null,

      lookRuleDialogShow: false,
      currentDirectRuleInfo: {},

      addRuleDialogShow: false,
      myRuleData: [],
      editRuleDialogShow: false,
      currentSubRuleData: [],
      currentSubIbInfo: {
        levelName: '',
        id: '',
      },

      channelType: 0,
      bankInfoDialogShow: false,
      barInfoDialogShow: false,
      usdtInfo: {},
      otcInfo: {},
    }
  },
  computed: {
    ...mapGetters(['userInfo']),
    outBtnDisable(){
      return !this.statistics.remainAmount
    },
    templateList() {
      if (this.myRuleData.length) {
        let emptList = JSON.parse(JSON.stringify(this.myRuleData));
        for (let i = 0; i < emptList.length; i++) {
          for (let j = 0; j < emptList[i].symbolGroup.length; j++) {
            emptList[i].symbolGroup[j].value = '';
          }
        }
        return emptList;
      } else {
        return [];
      }
    },
    channelInfo(){
      if(this.channelType == 2){
        return this.usdtInfo;
      }else {
        return this.otcInfo;
      }
    },
    barTitle(){
      if(this.channelType == 2){
        return 'USDT';
      }else if(this.channelType == 3){
        return this.$t('withdraw365');
      }
    },
  },
  created(){
    this.getPartnerCenterData();
    this.getStatisticsData();
    this.getList();
    this.getIbLevels();
    this.getSelfCommission();
  },
  methods: {
    addSuccess(){
      this.getIbLevels();
      this.addRuleDialogShow = false;
    },
    addCollection(channelType){
      this.queryPayTypes(() => {
        this.channelType = channelType;
        if(this.channelType == 1){
          this.bankInfoDialogShow = true;
        }else {
          this.barInfoDialogShow = true;
        }
      });
    },
    // 绑定收款信息的
    queryPayTypes(callback) {
      getCustPayTypes({
        custId: this.userInfo.id,
      }).then((res) => {
        for (let i = 0; i < res.data.length; i++) {
          if (res.data[i].payTypeId == 5) {
            this.usdtInfo = res.data[i];
          }
          if (res.data[i].payTypeId == 6) {
            this.otcInfo = res.data[i];
          }
        }
        callback();
      })
    },
    closeBankInfoHandel(){
      this.bankInfoDialogShow = false;
    },
    editBankInfoSuccess(){
      this.bankInfoDialogShow = false;
      this.updateCollectionInfo();
    },
    updateCollectionInfo(){
      let tochannel = this.$refs.outcommission.$refs.firststep;
      tochannel.getWithdrawList();
    },

    closeBarInfoHandel(){
      this.barInfoDialogShow = false;
    },
    barInfoAjaxSuccess(){
      this.barInfoDialogShow = false;
      this.updateCollectionInfo();
    },

    addSubLinkHandle(){
      this.addRuleDialogShow = true;
    },
    editSuccess(){
      this.getIbLevels();
      this.editRuleDialogShow = false;
    },
    editHandle(item){
      this.currentSubIbInfo = item;
      queryTMerchantCommissionLevelsRule({
        levelId: item.id,
      }).then((res) => {
        toggleStockMaxAndValue(res.data);
        this.currentSubRuleData = res.data;
        this.editRuleDialogShow = true;
      })

    },
    lookDirectRuleInfoHandle(directRuleInfo){
      this.currentDirectRuleInfo = directRuleInfo;
      this.lookRuleDialogShow = true;
    },
    closeLookDialog(){
      this.lookRuleDialogShow = false;
    },
    closeAddRuleDialog(){
      this.addRuleDialogShow = false;
    },
    closeEditRuleDialog(){
      this.editRuleDialogShow = false;
    },
    outCommissionSuccess(){
      this.getStatisticsData();
    },
    outHandle() {
      this.dialogShow = true;
    },
    getSelfCommission(){
      queryTMerchantCommissionLevelsRule({
        custId: this.userInfo.id,
      }).then((res) => {
        toggleStockMaxAndValue(res.data)
        this.myRuleData = res.data;
      })
    },
    getPartnerCenterData(){
      let parmas ={
        custId : this.userInfo.id
      };
      this.loading = true;
      getPartnerCenterData(parmas).then((res) => {
        this.loading = false;
        toggleStockMaxAndValue(res.data.ruleList)
        this.partner = res.data;
      })
    },
    getStatisticsData(){
      let parmas ={
        custId : this.userInfo.id
      };
      getPartnerInfo(parmas).then((res) => {
        this.statistics = res.data[0];
      })
    },
    getList() {
      let parmas = {
        custInfo: this.userInfo.id
      };
      getDirectGuestInvitationLinks(parmas).then((res) => {
        this.guestInvitationLinks = res.data.custLinks;
        this.isCanAddLinks = !res.data.foreignConfig; // 0是关闭,1是开启, // 开启时不能创建自定义链接
      });
    },
    getIbLevels(){
      queryTMerchantCommissionLevels({
        custId:this.userInfo.id
      }).then((res) => {
        this.subIbInfoList = res.data;
      })
    },
    copyHandle(link){
      copy(link);

      this.$message({
        type: 'success',
        message: this.$t('User.copySuccess')
      });

    },
  },
}
</script>

<style lang="scss" scoped>
.propagandas {
  .data-total,
  .my-rule,
  .customer-link
  {
    background-color: #ffffff;
    border-radius: 10px;
    margin-bottom: 24px;
  }

  .RuleTable-outer {
    overflow-x: auto;
  }

  .data-total {
    padding: 20px;
    .total-item {
      color: #5E5873;
      margin-bottom: 10px;
      .label {
        font-size: 14px;
        padding-bottom: 8px;
      }
      .data {
        font-size: 24px;
        font-weight: 500;
        &.special-data {
          display: flex;
          justify-content: flex-start;
          align-items: center;
          .outer-left-btn {
            margin-right: 10px;
          }
        }
      }
    }
  }

  .my-rule {
    .header {
      height: 54px;
      display: flex;
      padding: 10px 20px;
      justify-content: space-between;
      align-items: center;
      .title {
        font-weight: 600;
        font-size: 16px;
        color: #5E5873;
      }
      .tab-inner {
        margin-bottom: 0;
      }
    }
  }
  .customer-link {
    padding: 30px 20px;
    .link-group {
      margin-bottom: 30px;
    }
    .group-title {
      font-size: 16px;
      font-weight: 600;
      margin-bottom: 8px;
    }

    .bg-box {
      margin-bottom: 5px;
      display: flex;
      justify-content: flex-start;
      align-items:flex-start;
      flex-wrap: wrap;
      background-color: #FAFAFA;
      border-radius: 6px;
      padding: 20px;
      .bg-left {
        margin-right: 10px;
      }
      .bg-right {
        flex: 1;
      }
      .link-title {
        display: flex;
        justify-content: space-between;
        align-items: center;
      }
      .link-text {
        word-break:break-all;
      }
      .icon-edit-21 {
        margin-left: 10px;
      }
    }
    .subib-group-title {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 10px;
    }
  }

}
</style>
